goog.provide("shadow.js.shim.module$src$svg$wpp$content_actions$upload_svg$default");
shadow.js.shim.module$src$svg$wpp$content_actions$upload_svg$default = shadow.js.shim.module$src$svg$wpp$content_actions$upload_svg.default;
